import AppHeader from "@/components/AppHeader";

export default {
  name: "master",
  components: {
    AppHeader
  },
  methods: {
    authorityCheck(menu) {
      if (
        localStorage.user_authority == 1 ||
        (localStorage.user_authority == 4 && menu == "site")
      ) {
        // 総務部でログイン
        return true;
      } else if (
        localStorage.user_authority == 1 ||
        (localStorage.user_authority == 3 && menu == "phrase")
      ) {
        return true;
      }
      return false;
    }
  }
};
